module.exports = __webpack_public_path__ + "static/media/hotel_good.429a96d1.png";